import { EXTERNAL_SCOPE_BULK_CONCURRENCY } from './scope-constants';

export const chunkIds = ({
  ids,
  size,
}: {
  ids: string[];
  size: number;
}): string[][] =>
  Array.from({ length: Math.ceil(ids.length / size) }, (_, index) =>
    ids.slice(index * size, index * size + size),
  );

export const runInBatches = ({
  ids,
  run,
  size = EXTERNAL_SCOPE_BULK_CONCURRENCY,
}: {
  ids: string[];
  run: (id: string) => Promise<unknown>;
  size?: number;
}): Promise<void> =>
  chunkIds({ ids, size }).reduce<Promise<void>>(async (previous, batch) => {
    await previous;
    await Promise.all(batch.map(run));
  }, Promise.resolve());
